import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, createSlots as _createSlots, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_3 = {
  key: 0,
  class: "mr-24"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 上传对账明细 ")
const _hoisted_6 = {
  key: 1,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "hw_detail_table_header" }, null, -1)
const _hoisted_8 = {
  key: 0,
  style: {"font-size":"14px","color":"#aaa","font-weight":"normal","margin-left":"24px"}
}
const _hoisted_9 = {
  key: 3,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_10 = { class: "ml-24" }
const _hoisted_11 = { class: "ml-24" }
const _hoisted_12 = { class: "ml-24" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { key: 5 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "=", -1)
const _hoisted_20 = {
  key: 4,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_21 = {
  key: 0,
  class: "mr-24"
}
const _hoisted_22 = {
  key: 5,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_23 = {
  key: 0,
  class: "mr-24"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-weight":"700"},
  class: "mr-8"
}, "对账明细结果：", -1)
const _hoisted_25 = { class: "mr-8" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"700"} }, "暂估汇总：", -1)
const _hoisted_27 = { class: "mr-8" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"700"} }, "结算汇总：", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"700"} }, "差值汇总：", -1)
const _hoisted_30 = { key: 1 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_33 = {
  key: 6,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_34 = { style: {"font-size":"14px","color":"#aaa","font-weight":"normal","margin-left":"24px"} }
const _hoisted_35 = ["href"]
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 批量填写分成信息 ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 分成 ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 补贴 ")
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 7,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_51 = { style: {"background":"white","padding":"20px"} }
const _hoisted_52 = ["innerHTML"]
const _hoisted_53 = { style: {"text-align":"center","margin":"30px auto 10px auto"} }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("生成PDF并发送审核")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (!_ctx.isEmptyData(_ctx.bill) && !_ctx.isEmptyData(_ctx.billing) && !_ctx.bill.is_force_manual_mode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ((_ctx.tags.includes('ML') || _ctx.tags.includes('BX')) && _ctx.billing.billing_list.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_we_table, _mergeProps(_ctx.mediaMlbxConfig, {
                dataSource: _ctx.billing.billing_list,
                onRegister: _ctx.register
              }), _createSlots({
                code: _withCtx(({ record }) => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.jumpToProduct({ id: record.product_id }))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.rd_product_code), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, [
                (_ctx.billing.billing_list.length > 0)
                  ? {
                      name: "headerButton",
                      fn: _withCtx(() => [
                        (_ctx.billing.billing_list.length > 10)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                              _createVNode(_component_a_button, {
                                type: "link",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expandBilling = !_ctx.expandBilling))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.expandBilling ? '显示分页' : '显示全部'), 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.canDoDetailBilling)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 1,
                              type: "primary",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editProductBilling()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.canDoDetailBilling && _ctx.bill.is_supply)
                          ? (_openBlock(), _createBlock(_component_a_button, {
                              key: 2,
                              type: "primary",
                              onClick: _ctx.uploadInvoiceExcel
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    }
                  : undefined
              ]), 1040, ["dataSource", "onRegister"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tags.includes('MSRebate') && _ctx.billing.billing_list.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_we_table, _mergeProps(_ctx.mediaMlbxRebateConfig, {
                dataSource: _ctx.billing.billing_list
              }), {
                headerButton: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expandBilling = !_ctx.expandBilling))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.expandBilling ? 'Show-Paged' : 'Show-All'), 1)
                    ]),
                    _: 1
                  })
                ]),
                code: _withCtx(({ record }) => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.jumpToProduct({ id: record.product_id }))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.rd_product_code), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 16, ["dataSource"])
            ]))
          : _createCommentVNode("", true),
        (
        _ctx.tags.includes('MSCustomer') && _ctx.bill.month >= '2021-10' && _ctx.billing.ms_billings && _ctx.billing.ms_billings.length > 0
      )
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.billing.ms_billings, (b, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "hw_detail_table_container card-white-6",
                key: i
              }, [
                _createVNode(_component_we_table, _mergeProps({
                  dataSource: b.billing_list
                }, _ctx.mediaMsConfig), {
                  table_title: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(b.name), 1),
                    (b.result_desc)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(b.result_desc), 1))
                      : _createCommentVNode("", true)
                  ]),
                  code: _withCtx(({ record }) => [
                    _createVNode(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (_ctx.jumpToProduct({ id: record.product_id }))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.rd_product_code), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1040, ["dataSource"])
              ]))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.tags.includes('Cloud'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_we_table, _mergeProps(_ctx.cloudBillingDataConfig, {
                dataSource: _ctx.billing.billing_list
              }), {
                headerButton: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_10, "Cost: $" + _toDisplayString(_ctx.formatMoneyByRound(_ctx.billing.result_cost, 2, !_ctx.isAWS)), 1),
                    _createElementVNode("span", _hoisted_11, "Billing Result: $" + _toDisplayString(_ctx.formatMoneyByRound(_ctx.billing.result_computed, 2, !_ctx.isAWS)), 1),
                    _createElementVNode("span", _hoisted_12, [
                      _createElementVNode("span", null, " Billing Final: " + _toDisplayString(_ctx.formatMoneyByRound(_ctx.billing.result_computed, 2, !_ctx.isAWS)), 1),
                      (_ctx.billing.currency_name !== 'USD')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "*"))
                        : _createCommentVNode("", true),
                      (_ctx.billing.currency_name !== 'USD')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.formatMoneyByRound(_ctx.billing.currency_rate, 4)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.billing.config.contract_config.tax)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, "*"))
                        : _createCommentVNode("", true),
                      (_ctx.billing.config.contract_config.tax)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, " (1 + " + _toDisplayString(_ctx.formatMoneyByRound((_ctx.billing.config.contract_config.tax || 0) * 100, 2)) + "%) ", 1))
                        : _createCommentVNode("", true),
                      (_ctx.billing.result_adjust)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "+"))
                        : _createCommentVNode("", true),
                      (_ctx.billing.result_adjust)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "(" + _toDisplayString(_ctx.formatMoneyByRound(_ctx.billing.result_adjust)) + ")", 1))
                        : _createCommentVNode("", true),
                      _hoisted_19,
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency(_ctx.billing.result_final, _ctx.billing.currency_name)), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 16, ["dataSource"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tags.includes('Cash'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_we_table, _mergeProps(_ctx.cashBillingConfig, {
                dataSource: _ctx.billing.billing_list
              }), {
                code: _withCtx(({ record }) => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.jumpToProduct({ id: record.product_id }))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(record.product__code), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                headerButton: _withCtx(() => [
                  (_ctx.billing.result_desc)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Billing Result: " + _toDisplayString(_ctx.billing.result_desc), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 16, ["dataSource"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tags.includes('AppMeta') || _ctx.tags.includes('DSP'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_we_table, _mergeProps(_ctx.scalerBillingConfig, {
                dataSource: _ctx.billing.billing_list
              }), {
                headerButton: _withCtx(() => [
                  (_ctx.billing.result_desc)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                        _hoisted_24,
                        _createElementVNode("span", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("span", null, _toDisplayString(_ctx.billing.all_gmv), 1)
                        ]),
                        _createElementVNode("span", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("span", null, _toDisplayString(_ctx.billing.all_billing_money), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_29,
                          _createElementVNode("span", null, _toDisplayString(_ctx.formatNumberByNumeral(_ctx.billing.all_billing_money - _ctx.billing.all_gmv, '0,0.00')), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.show_bill_table_button)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                        _createVNode(_component_a_button, {
                          type: "primary",
                          onClick: _ctx.handle_scaler_import
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                diff: _withCtx(({ record }) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatNumberByNumeral(_ctx.get_diff(record), '0,0.00')), 1)
                ]),
                action: _withCtx(({ record }) => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.handle_edit_scaler_record(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 16, ["dataSource"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tags.includes('Pub') && !_ctx.isEmptyData(_ctx.pubBillingDataSource))
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createVNode(_component_we_table, _mergeProps(_ctx.pubBillingConfig, {
                dataSource: _ctx.pubBillingDataSource,
                useSearchForm: false,
                pagination: false,
                onSelectionChange: _ctx.setselectedBillingIds,
                rowKey: "product_id",
                rowSelection: {
          type: 'checkbox',
          getCheckboxProps: _ctx.getCheckboxProps,
        }
              }), {
                table_title: _withCtx(() => [
                  _createElementVNode("span", null, "发行对账(" + _toDisplayString(_ctx.bill.rd_currency_name) + ")", 1),
                  _createElementVNode("span", _hoisted_34, " 总金额 + 调整项: " + _toDisplayString(_ctx.formatMoneyByRound(_ctx.billing.result)), 1)
                ]),
                headerButton: _withCtx(() => [
                  (!_ctx.isEmptyData(_ctx.pubBillingLog) && (_ctx.canBilling || _ctx.isMine))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "ml-24",
                        style: {"text-decoration":"none"},
                        href: _ctx.pubBillingLog.confirmation.confirmation_url
                      }, _toDisplayString(_ctx.pubBillingLog.confirmation.confirmation_info.is_manual ? '(手工)' : '') + "确认函 ", 9, _hoisted_35))
                    : _createCommentVNode("", true),
                  (_ctx.canBilling || _ctx.isMine)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "primary",
                        class: "ml-24",
                        onClick: _ctx.batchEditDivideInfo
                      }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                action: _withCtx(({ record }) => [
                  (_ctx.canBilling && record.product_id && !record.is_sum_by_group)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "link",
                        class: "mr-3",
                        onClick: ($event: any) => (_ctx.editPubBillingDivide(record, 'divide'))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_37
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.pubBillingShowGrant && !record.is_sum_by_group)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        onClick: ($event: any) => (_ctx.editPubBillingDivide(record, 'grant')),
                        type: "link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                divide_ratio: _withCtx(({ text }) => [
                  text
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(text * 100) + "%", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_40, "-"))
                ]),
                divide_amount: _withCtx(({ text, record }) => [
                  (record.divide_count_in)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.formatMoneyByRound(text)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_42, "0"))
                ]),
                _: 1
              }, 16, ["dataSource", "onSelectionChange", "rowSelection"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.tags.includes('UseAdjust') || !_ctx.isEmptyData(_ctx.billing.adjust_list))
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createVNode(_component_we_table, _mergeProps(_ctx.billingAdjustConfig, {
                dataSource: _ctx.billing.adjust_list || [],
                useSearchForm: false,
                pagination: false
              }), {
                headerButton: _withCtx(() => [
                  (_ctx.canBilling)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editAdjustment(null)))
                      }, {
                        icon: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-name": "PlusCircleOutlined" })
                        ]),
                        default: _withCtx(() => [
                          _hoisted_44
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                ratio: _withCtx(({ text, record }) => [
                  (record.count_in)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(text) + "%", 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_46, "-"))
                ]),
                real_money: _withCtx(({ text, record }) => [
                  (record.count_in)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(text), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_48, "-"))
                ]),
                adjust_action: _withCtx(({ record }) => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.editAdjustment(record)),
                    class: "mr-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_49
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (_ctx.deleteAdjustment(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_50
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 16, ["dataSource"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_modal, {
          visible: _ctx.showPubCfm,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showPubCfm) = $event)),
          width: "900px",
          centered: ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_53, [
              _createVNode(_component_a_button, {
                type: "primary",
                loading: _ctx.savingPubCfm,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPubCfm = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_54
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_a_button, {
                type: "primary",
                loading: _ctx.savingPubCfm,
                onClick: _ctx.savePubCfm
              }, {
                default: _withCtx(() => [
                  _hoisted_55
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", {
                innerHTML: _ctx.showPubCfmHtml,
                id: "pub_cfm_html_content",
                style: {"min-width":"800px","margin":"auto"}
              }, null, 8, _hoisted_52)
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}